<h1 mat-dialog-title i18n>New legal document</h1>
<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content px-3">
		<div class="col-12 px-0 top-margin-20">
			<div class="col-12 px-0">
				<mat-form-field appearance="standard" class="col col-md-6" *ngIf="dialogData?.cluster">
					<mat-label i18n>Cluster</mat-label>
					<mat-select formControlName="cluster">
						<mat-option
							*ngFor="let cluster of dialogData.cluster.clusters"
							[value]="cluster.clusterId"
						>{{ cluster.name }} - {{cluster.clusterId}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<mat-form-field appearance="standard" class="col-4" *ngIf="dialogData.type !== termType.app">
				<mat-label i18n>Language</mat-label>
				<mat-select formControlName="locale" >
					<mat-option *ngFor="let option of locales" [value]="option.value">{{ option.label }}</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-4 legal-new__version-field">
				<mat-label i18n>Version</mat-label>
				<input matInput type="string" placeholder="1.0" formControlName="version" />
				<mat-error
					appFormErrorMessage
					[errorFormControl]="formInputs.controls.version"
					[type]="formEditorInputType.text"
				></mat-error>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-4 legal-new__status-field">
				<mat-label i18n>Status</mat-label>
				<mat-select formControlName="active" >
					<mat-option *ngFor="let option of statuses" [value]="option.value">{{ option.label }}</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-sm-6 legal-new__name-field">
				<mat-label i18n>Document name</mat-label>
				<input matInput type="text" placeholder="Name" i18n-placeholder formControlName="name" />
				<mat-error
					appFormErrorMessage
					[errorFormControl]="formInputs.controls.name"
					[type]="formEditorInputType.text"
				></mat-error>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-sm-6 legal-new__alias-field" *ngIf="dialogData.type === termType.app">
				<mat-label i18n>Document alias</mat-label>
				<input matInput type="text" placeholder="Alias" i18n-placeholder formControlName="alias" />
				<mat-error
					appFormErrorMessage
					[errorFormControl]="formInputs.controls.alias"
					[type]="formEditorInputType.text"
				></mat-error>
			</mat-form-field>

			<div class="col-12 mb-2" *ngIf="dialogData.type === termType.app">
				<label class="d-block">Provide document via:</label>
				<mat-radio-group formControlName="fileType" class="legal-new__document-type-field">
					<mat-radio-button id="{{fileTypes.url}}" class="ml-3" [value]="fileTypes.url">File URL</mat-radio-button>
				</mat-radio-group>
			</div>

			<mat-form-field appearance="standard" class="col-12 legal-new__url-field">
				<mat-label i18n>URL</mat-label>
				<input matInput type="url" placeholder="URL" i18n-placeholder formControlName="url" />
				<mat-error
					appFormErrorMessage
					[errorFormControl]="formInputs.controls.url"
					[type]="formEditorInputType.url"
				></mat-error>
			</mat-form-field>

			<div class="col-12 mt-4" *ngIf="dialogData.type === termType.app">
				<app-legal-app-localisation [(formInputs)]="formInputs"></app-legal-app-localisation>
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="row px-1 mb-0">
		<div class="col-6 text-center">
			<button class="w-100" mat-flat-button mat-dialog-close (click)="cancel()" i18n>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button class="w-100 legal-new__submit" [disabled]="!formIsValid" type="submit" mat-flat-button color="primary" i18n>Ok</button>
		</div>
	</div>
</form>
